export default "__VITE_ASSET__c0405125__"